import React from 'react';
import { Card, CardContent, Skeleton, Box, Typography, Chip } from '@mui/material';
import { useLanguage } from '../../../../context/LanguageContext';

interface StoreInfoSkeletonProps {
    hasAction?: boolean;
}

const StoreInfoSkeleton = ({ hasAction = false }: StoreInfoSkeletonProps) => {
    const { t } = useLanguage();

    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Skeleton variant="text" width={200} height={28} />
                        <Skeleton variant="text" width={60} height={20} />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: '12px' }} />
                        {hasAction && <Skeleton variant="rectangular" width={70} height={30} sx={{ borderRadius: 1 }} />}
                    </Box>
                </Box>
                
                <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                        {[
                            t('pages.store.storeNumber'),
                            t('pages.store.internalCode'),
                            t('pages.store.type'),
                            t('pages.store.franchise'),
                            t('pages.store.transactionMode'),
                            t('pages.store.advancePayment')
                        ].map((label, index) => (
                            <tr key={index}>
                                <td style={{ padding: '8px 0', verticalAlign: 'top', width: '50%' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{label}</Typography>
                                </td>
                                <td style={{ padding: '8px 0', paddingLeft: '16px' }}>
                                    {index >= 2 ? (
                                        <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '12px' }} />
                                    ) : (
                                        <Skeleton variant="text" width="60%" height={20} />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Box>
            </CardContent>
        </Card>
    );
};

export default StoreInfoSkeleton;
